import React from 'react';
import SimpleLogicTerm from './SimpleLogicTerm';

export default function SimpleLogicList({
  logic,
  pages,
  showChoiceLabel,
}) {
  if (!logic || !logic.length) return null;
  return (
    <span className={`srv_skps ${showChoiceLabel ? 'pull-right' : ''}`}>
      {logic.map(term => (
        <SimpleLogicTerm
          key={term._id}
          {...term}
          pages={pages}
          showChoiceLabel={showChoiceLabel}
        />
      ))}
    </span>
  );
}
